import { Injectable } from '@angular/core';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({ providedIn: 'root' })
export class AcReportLayoutService {
    constructor(private datatask: DataTaskService) {}

    public async getMenu(acreportlayoutKeyno: string | number): Promise<AcReportLayoutMenuGet> {
        return (await this.datatask.Post(2802, { acreportlayout_keyno: acreportlayoutKeyno }))[0];
    }

    public async renumber(menu: AcReportLayoutMenuGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(2809, menu))[0];
    }

    public async copy(menu: AcReportLayoutMenuGet): Promise<ErrorMessageResponse> {
        return (await this.datatask.Post(2814, menu))[0];
    }

    public async delete(menu: AcReportLayoutMenuGet): Promise<ErrorMessageResponse | undefined> {
        return (await this.datatask.Post(2816, menu))[0];
    }
}

export interface AcReportLayoutMenuGet {
    acreportlayout_keyno: string;
    acreportlayout_name: string;
    res: string;
}
